'use strict'

import ProductCard from '@ui/Product/Card/component'
import CardsHighlightSlider from 'assets/themes/campings/js/module/cardsHighlightSlider'

export default function (): void {
  const rootEl = document.getElementById('best-rated-campings-slider')

  if (!rootEl) {
    return
  }

  CardsHighlightSlider(rootEl, {
    navigation: {
      nextEl: '#best-rated-campings-slider-next',
      prevEl: '#best-rated-campings-slider-prev',
    },
    pagination: {
      el: '#best-rated-campings-slider-pagination',
    },
    loop: document.querySelectorAll('#best-rated-campings-slider .swiper-slide').length > 1,
  })

  rootEl.querySelectorAll<HTMLElement>('.product-card').forEach((element) => {
    ProductCard(element)
  })
}
